export interface ButtonGroupOption<T> {
  value: T;
  label: string;
}

export function ButtonGroup<T extends string | number>({
  label,
  value,
  onChange,
  options,
}: {
  label: string;
  value: T;
  onChange: (v: T) => void;
  options: ButtonGroupOption<T>[];
}) {
  return (
    <div className="flex items-center gap-3">
      <label className="text-sm font-semibold text-white/80 flex-1 min-w-0">
        {label}
      </label>
      <div
        role="radiogroup"
        className="flex w-80 bg-brand-ink rounded-lg divide-x divide-white/10 overflow-hidden flex-shrink-0"
      >
        {options.map((opt) => {
          const selected = opt.value === value;
          return (
            <button
              key={String(opt.value)}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => onChange(opt.value)}
              className={`flex-1 px-2 py-2 text-sm font-semibold transition-colors text-center whitespace-nowrap ${
                selected
                  ? "bg-brand-green text-white"
                  : "text-white/70 hover:text-white hover:bg-brand-ink3"
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
